import { render, staticRenderFns } from "./WardOrganizations.vue?vue&type=template&id=f3bea25c&"
import script from "./WardOrganizations.vue?vue&type=script&lang=js&"
export * from "./WardOrganizations.vue?vue&type=script&lang=js&"
import style0 from "./WardOrganizations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports